
import { Component, Prop, Vue } from "vue-property-decorator";
import VModal from "vue-js-modal";

import UdcBannerGeneric from "@/components/UdcBannerGeneric.vue";

Vue.use(VModal);

@Component({
  name: "celebrus-hb-popin",
  components: {
    UdcBannerGeneric
  }
})
export default class CelebrusHbPopin extends Vue {
  @Prop() private banner!: any;
  @Prop() private methods!: any;

  public data() {
    return {
      popinHeight: "auto"
    };
  }

  public mounted() {
    this.$modal.show("generic-popin");
  }

  private async onCloseClick() {
    this.$modal.hide("generic-popin");
    if (this.getCrossReponse()) {
      this.banner.celebrusHelper.custom(this.getCrossReponse());
    } else {
      this.banner.celebrusHelper.refused();
    }
  }
  private getCrossReponse() {
    return this.banner.crossAnswer;
  }

  private getImgBanner() {
    return this.banner.imgBanner;
  }
}
